/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Without_ConfirmationInputs */

const en_queue_sos_without_confirmation = /** @type {(inputs: Queue_Sos_Without_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders without an order confirmation`)
};

/**
* | output |
* | --- |
* | "Sales orders without an order confirmation" |
*
* @param {Queue_Sos_Without_ConfirmationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_without_confirmation = /** @type {((inputs?: Queue_Sos_Without_ConfirmationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Without_ConfirmationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_without_confirmation(inputs)
});